export enum SupportDetailActionEnum {
    cancel = 'Anular',
    exchange = 'Trocar',
    load = 'Vender',
    transfer = 'Transferir'
}
